import React from 'react'
import { observer } from 'mobx-react'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import { Modal } from 'suomifi-ui-components'

const Dialog = observer((): React.JSX.Element => {
  const { dialogs } = useStore()
  const [dialogItem] = dialogs
  return (
    <Modal visible={!!dialogItem?.active} appElementId="app">
      {
        dialogItem ? <dialogItem.component dialogItem={dialogItem} /> : <div /> // Modal can't be empty
      }
    </Modal>
  )
})

export default Dialog
